/**
 * Filter
 *
 * Adds a simple JS Filter
 */

(function Accordion() {
    const elements = $('.has-filter');
    const classes = {
        active: 'is-active'
    };

    /**
     * Create
     */
    function create() {
        $.each(elements, function(index, element) {
            initializeFilter($(element));
        });
    }

    function initializeFilter(filterElement) {
        filterElement.find('a').removeAttr('href');
        filterElement.find('li').on('click', function() {
            toggleFilterItems($(filterElement.data('target')), $(this));
        });
    }

    function toggleFilterItems(child, filterItem) {
        let value = filterItem.data('filter-trigger');

        child.find('[data-filter-item]').hide();
        child.find('[data-filter-item="' + value + '"]').fadeIn(150);

        filterItem.siblings().removeClass(classes.active);
        filterItem.addClass(classes.active);

        if (value == 'all') {
            child.find('.filter').show();
        }
    }

    if (elements.length > 0) {
        create();
    }
})();